// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'orgHeader.orgLogo': 'Organization Logo',
  'orgHeader.TCLogo': 'TigerConnect Company Logo',
  'attachmentBanners.attachments': 'Attachments',
  'attachmentBanners.removeAttachment': 'Remove attachment',
  'accessCodeForm.birthdayMonth': 'Birthday Month',
  'accessCodeForm.birthdayDay': 'Birthday Day',
  'accessCodeForm.birthdayYear': 'Birthday Year',
  'composeArea.formLabel': 'Send Message Form',
  'composeArea.addAttachment': 'Add Attachment',
  'conversationPane.youHaveNewMessages':
    'You have {count} new {count, plural, one {message} other {messages}}',
  'conversationPane.goToNewMessages': 'Go to new messages',
  'conversationPane.newMessages': 'New messages',
  'conversationPane.conversationLabel': 'Conversation Message List',
  'pageTitle.pageTitle': 'TigerConnect Mobile Messenger',
  'pageTitle.newMessagePageTitle': 'New Message: TigerConnect Mobile Messenger',
  'messageItem.messageFailed': 'Message failed to send',
  'messageStatusFailedRetry.delete': 'Delete',
  'messageStatusFailedRetry.sending': 'Sending...',
  'messageStatusFailedRetry.resend': 'Resend',
  'messageStatusFailedRetry.deleteFailedMessage': 'Delete failed message',
  'messageStatusFailedRetry.resendFailedMessage': 'Resend failed message',
};
